import script from "./applyPayment.vue?vue&type=script&lang=ts&setup=true"
export * from "./applyPayment.vue?vue&type=script&lang=ts&setup=true"

import "./applyPayment.vue?vue&type=style&index=0&id=13b7339c&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13b7339c"]])

export default __exports__